var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdLivelinessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 19.8H5.59941C4.49511 19.8 3.59961 18.9045 3.59961 17.8002V3.79985C3.59961 2.69555 4.49511 1.80005 5.59941 1.80005H15.9998C17.1041 1.80005 17.9996 2.69555 17.9996 3.79985V17.8002C17.9996 18.9045 17.1041 19.8 15.9998 19.8Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7991 4.5C8.4654 6.9912 8.4654 11.0088 10.7991 13.5C13.1328 11.0088 13.1328 6.9912 10.7991 4.5Z",
    stroke: "#F1F3F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 4.5C13.292 4.5 15.3008 6.5088 15.3008 9C15.3008 11.4912 13.292 13.5 10.8008 13.5",
    stroke: "#F1F3F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 13.5C8.30958 13.5 6.30078 11.4912 6.30078 9C6.30078 6.5088 8.30958 4.5 10.8008 4.5",
    stroke: "#F1F3F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30078 9.00005H15.3008",
    stroke: "#F1F3F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4996 16.65H8.09961",
    stroke: "#F1F3F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdLivelinessCheck);
export default __webpack_public_path__ + "static/media/id_liveliness_check.634e472a7963249f20cdc33a18aa8569.svg";
export { ForwardRef as ReactComponent };